import { apiAuthBaseUrl } from '@/logic/configuration.ts'
import authApiClient from '@/features/shared/data/axios.interceptor.ts'

export const AlgoliaService = {
  getApiKey: async (): Promise<string> => {
    const response = await authApiClient.get<{ key: string }>(
      `${apiAuthBaseUrl}/users/generate-algolia-key`
    )
    return response.data.key
  },
}
